export default __webpack_public_path__ + "static/media/arrow-new-left.a391a454.svg";